import React, { Fragment } from 'react';
import T from 'prop-types';
import { isArray } from 'lodash-es';

import AppIcon from '../../../../components/AppIcon';
import Container from '../../../../components/Container';
import Button from '../../../../components/Buttons/Button';

import { getActiveOption } from '../../../prospects/_shared/configs/predefined-ranges';
import scrollPage from '../../../../utils/scrollPage';
import { truncateTicker } from '../../../../utils/helpers';

const nomalizedStore = {
  unified: 'Unified',
  itunes_connect: 'IOS',
  google_play: 'Google',
};

const ShadowHeader = ({
  app,
  filters,
  additionalContent,
}) => {
  const date = getActiveOption({
    date_from: filters.period_from_date,
    date_to: filters.period_to_date,
    period: filters.period,
  });

  let country;
  if (filters.country_iso) {
    if (isArray(filters.country_iso)) {
      if (filters.country_iso.length === 1) {
        country = filters.country_iso[0] === 'WW' ? 'Worldwide' : COUNTRIES_ARRAY[filters.country_iso[0]];
      } else {
        country = 'Multiple Countries';
      }
    } else {
      country = COUNTRIES_ARRAY[filters.country_iso];
    }
  }

  return (
    <div className="app-insights-summary__header-min-box">
      <div className="app-insights-summary__header-min">
        <Container maxWidth={1128}>
          <div className="app-insights-summary__header-min-content">
            <div className="app-insights-summary__header-min-app-data">
              <Button shape="square" variant="secondary" onClick={() => scrollPage()}>
                <i className="hicon-arrow-up-new" />
              </Button>
              <div className="app-insights-summary__header-min-app">
                <AppIcon
                  containerClasses="app-insights-summary__header-min-app-icon"
                  alt={app.name}
                  url={app.icon_url_2x}
                  url2x={app.icon_url_2x}
                  store={app.store}
                  size={32}
                />
                <div className="app-insights-summary__header-min-app-info">
                  <p className="app-name text-truncate">{app.name}</p>
                  <div className="app-insights-summary__header-min-app-filters">
                    {filters.page && (
                      <Fragment>
                        <p>{filters.page}</p>
                        <span>•</span>
                      </Fragment>
                    )}
                    <p>{nomalizedStore[filters.store]}</p>
                    {country && (
                      <Fragment>
                        <span>•</span>
                        <p>{country}</p>
                      </Fragment>
                    )}
                    {date.label && (
                      <Fragment>
                        <span>•</span>
                        <p>{date.label}</p>
                      </Fragment>
                    )}
                  </div>
                </div>
                {app.company_ticker && (
                  <span className="app-insights-summary__header-min-company-ticker">{truncateTicker(app.company_ticker)}</span>
                )}
              </div>
            </div>
            {additionalContent}
          </div>
        </Container>
      </div>
    </div>
  );
};

ShadowHeader.propTypes = {
  filters: T.object,
  app: T.object,
  additionalContent: T.node,
};

export default ShadowHeader;
